import { Component, onMount } from 'solid-js'
import { Page } from '/web/Layout'
import PageHeader from '/web/shared/PageHeader'
import { useNavigate, useSearchParams } from '@solidjs/router'
import TextInput from '/web/shared/TextInput'
import { createStore } from 'solid-js/store'
import Button from '/web/shared/Button'
import { toastStore, userStore, i18nStore } from '/web/store'
import { Card } from '/web/shared/Card'

export const ResetPasswordPage: Component = () => {
  const [params] = useSearchParams()
  const nav = useNavigate()
  const i18n = i18nStore((s) => ({ t: s.t }))

  const [state, setState] = createStore({ username: '', password: '', confirm: '' })

  const resetPassword = () => {
    if (!params.code) return
    if (!state.username) return
    if (!state.password || !state.confirm) return

    if (state.password !== state.confirm) {
      toastStore.warn(i18n.t.passwordsDoNotMatch)
      return
    }

    userStore.resetPassword(params.code!, state.username, state.password, state.confirm, () => {
      nav('/login')
    })
  }

  onMount(() => {
    if (params.code) return
    nav('/')
  })

  return (
    <Page>
      <PageHeader title={i18n.t.login_reset_password} />

      <div class="flex w-full justify-center">
        <Card bg="hl-300" class="w-full max-w-96">
          <div class="flex w-full flex-col items-center gap-2">
            <TextInput
              parentClass="w-full"
              placeholder={i18n.t.login_username_placeholder}
              value={state.username}
              onChange={(ev) => setState({ username: ev.currentTarget.value })}
            />

            <TextInput
              type="password"
              parentClass="w-full"
              placeholder={i18n.t.login_password_placeholder}
              value={state.password}
              onChange={(ev) => setState({ password: ev.currentTarget.value })}
            />

            <TextInput
              type="password"
              parentClass="w-full"
              placeholder={i18n.t.login_confirm_password_placeholder}
              value={state.confirm}
              onChange={(ev) => setState({ confirm: ev.currentTarget.value })}
            />

            <Button onClick={resetPassword}>{i18n.t.login_reset_password}</Button>
          </div>
        </Card>
      </div>
    </Page>
  )
}
